import { consoleRoutes } from "@sagot/constants";
import type { IconName, NotificationTone } from "@sagot/ui";
import { bookingsHref } from "../lib/booking-links";

/** Notification type → icon/tone/destination (mockup rows: handoff, processed source, gaps, bookings). */
export function present(type: string, ws: string): { icon: IconName; tone: NotificationTone; href: string } {
  if (type.includes("handoff")) return { icon: "headset", tone: "danger", href: consoleRoutes.inbox(ws) };
  if (type.includes("failed")) return { icon: "alert-circle", tone: "danger", href: consoleRoutes.settings(ws) };
  if (type.includes("source")) return { icon: "check-circle", tone: "success", href: consoleRoutes.dashboard(ws) };
  if (type.includes("gap")) return { icon: "help-circle", tone: "warning", href: consoleRoutes.gaps(ws) };
  if (type.includes("booking")) return { icon: "calendar", tone: "info", href: bookingsHref(ws) };
  if (type.includes("lead")) return { icon: "user-check", tone: "info", href: consoleRoutes.leads(ws) };
  if (type.includes("usage") || type.includes("payment")) return { icon: "credit-card", tone: "warning", href: consoleRoutes.billing(ws) };
  return { icon: "bell", tone: "info", href: consoleRoutes.dashboard(ws) };
}
